import { useEffect, useState } from "react";

// components
import {
  Autocomplete,
  Button,
  Card,
  CardActions,
  CardContent,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  IconButtonProps,
  Typography,
  styled,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import LoadingScreen from "base/ui/components/LoadingScreen/loadingScreen";

// data

// icons
import TextField from "@mui/material/TextField";
import { BiMinus } from "react-icons/bi";
import { RiAddFill } from "react-icons/ri";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { ListStatusProduct } from "services/commonDate_services";
import * as rootStore from "stores/root_store";
import { workOrderPresenter, workOrderStore } from "stores/root_store";
import { formatNumber } from "utils/formatHelper";
import { Style } from "./styles";
import { Input } from "antd";
import { StatusMes } from "services/workOrder_services";
import { getRoles } from 'utils/localStorageHelper';

const { TextArea } = Input;


// Kiểm tra role admin
let checkAdmin = false
if (typeof getRoles() === 'string') {
  checkAdmin = getRoles().includes('ADMIN') ? true : false
}



export interface CardItemProp {
  title: string;
  className?: string;
  // dataShared?: Array<any>;
  shared?: boolean;
  data: Array<any>;
  woMolds?: boolean;
  routingDetails?: boolean;
  components?: boolean;
  idMatchCard?: string;
}

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const CardItem = (props: CardItemProp) => {
  // list Trạng thái MES
  const [mesStatus, setMesStatus] = useState<ListStatusProduct[]>([]);
  const [expanded, setExpanded] = useState(true);
  // value trạng thái MES
  const [value, setValue] = useState<ListStatusProduct | null>();
  // Sử dụng useState lưu trạng thái loading
  const [loading, setLoading] = useState(false);

  // ======================FUNCTION ====================================
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  //#Xử lý modal
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const [updateStatusLSX, setUpdateStatusLSX] = useState<StatusMes>();
  const handleClose = async (status: string) => {
    if (status === "ignore") return setOpen(false);
    if (updateStatusLSX) {
      Object.assign(updateStatusLSX, {
        productionStatus: updateStatusLSX.productionStatus?.key,
      });
    }
    setLoading(true);
    setOpen(false);
    await workOrderPresenter.updateProductionStatus(
      workOrderStore,
      updateStatusLSX
    );
    if (workOrderStore.updateProductionStatus.isSuccess) {
      toast.success(workOrderStore.updateProductionStatus.message);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
    // else {
    //   toast.error(workOrderStore.updateProductionStatus.message);
    // }
    setLoading(false);
  };
  //#end Xử lý modal

  const handleChange = async (
    event: React.SyntheticEvent<Element, Event>,
    newValue: ListStatusProduct | null
  ) => {
    setUpdateStatusLSX({ ...updateStatusLSX, productionStatus: newValue });
  };

  // Hàm lấy dropdown trạng thái MES
  const getListDropDownMesStatus = async (keywword = "WorkOrderStatusMes") => {
    await rootStore.commonDatePresenter.getDropdownByKeyword(
      rootStore.commonDateStore,
      keywword
    );
    setMesStatus(rootStore.commonDateStore.dropdownByKey);
  };
  // =====================Use Effect =======================================

  useEffect(() => {
    const getColumn = async () => {
      await getListDropDownMesStatus();
    };
    getColumn();
  }, []);
  // lấy value của trạng thái MES lúc đầu
  useEffect(() => {
    const temp = mesStatus
      .map((item) => {
        return { key: item.key, value: item.value };
      })
      .filter(
        (i) =>
          i.key ===
          workOrderStore.getWODetailsResponse.data?.productionStatusCode
      );
    setValue(temp[0] ?? null); //undefind thì trả về null
    setUpdateStatusLSX({
      ...updateStatusLSX,
      workorderCode: workOrderStore.getWODetailsResponse.data?.workOrderCode,
    });
  }, [workOrderStore.getWODetailsResponse.data, mesStatus]);

  return (
    <>
      {loading && <LoadingScreen />}
      <Card className={props.className}>
        <CardActions disableSpacing className="bg-primary !p-1">
          <Typography className="!text-default text-white !ml-3">
            {props.title}
          </Typography>
          <ExpandMore
            expand={expanded}
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="show more"
          >
            {expanded ? (
              <BiMinus className="!text-white !text-base" />
            ) : (
              <RiAddFill className="!text-white !text-base" />
            )}
          </ExpandMore>
        </CardActions>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent className="border rounded-b border-primary !pb-3">
            {props.shared && (
              <Grid container spacing={3} className="divide-x-2 pt-3">
                {props.data.map((item, index) => (
                  <Grid
                    item
                    xs={4}
                    key={index}
                    display="flex"
                    className="!pt-3"
                  >
                    <Grid container display={"flex"}>
                      <Grid item xs={5}>
                        <h3 className="font-medium">{item.title}</h3>
                      </Grid>
                      <Grid item xs={7}>
                        {item.input ? (
                          item.title === "Lệnh thiết kế" ? (
                            props.idMatchCard ? (
                              <Link
                                className="text-blue-700"
                                target="_blank"
                                to={`/Work/MassWorkOrder/matchCardCommandId=${props.idMatchCard}`}
                              >
                                {item.value}
                              </Link>
                            ) : (
                              item.value
                            )
                          ) : (
                            <Autocomplete
                              size="small"
                              className="col-span-2 text-gray-700 p-0 hover:ring-0 hover:outline-none hover:border-gray-300 !rounded-none border-border_input sm:ml-5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                              id="disabled-options-demo"
                              options={mesStatus}
                              //Không cho nhập
                              onKeyPress={(e) => {
                                e.preventDefault();
                              }}
                              sx={Style}
                              classes={{
                                root: "!ml-0",
                                listbox: "text-default !ml-0",
                                input: "!text-gray-700 !px-6 !py-0 !ml-0",
                                noOptions: "text-default",
                              }}
                              // onKeyDown khi nhấn nút Backspace không cho xóa
                              onKeyDown={(event: any) => {
                                if (event.key === "Backspace") {
                                  event.preventDefault();
                                }
                              }}
                              onChange={(event, newValue, reason) => {
                                if (!Array.isArray(newValue)) {
                                  if (reason !== "clear") {
                                    handleChange(event, newValue);
                                    handleClickOpen();
                                  }
                                }
                              }}
                              isOptionEqualToValue={(option, value) =>
                                option.key === value.key
                              }
                              disableClearable={value !== null} // disable close button but value not be undefined
                              value={value ?? null} //là null hoặc undefined, thì nó trả về giá trị bên phải
                              disabled={
                                workOrderStore.getWODetailsResponse.data
                                  ?.printStatus === ("Closed" || "Planneds") && !checkAdmin
                              }
                              clearIcon={false}
                              // getOptionDisabled={(option) =>
                              //   option === mesStatus[0]
                              // }
                              getOptionLabel={(option) => option.value}
                              // renderOption={(option) => option}
                              renderInput={(params) => (
                                <TextField {...params} />
                              )}
                            />
                          )
                        ) : (
                          <p>
                            {typeof item.value == "number"
                              ? `${formatNumber(item.value, 0)}`
                              : `${item.value === null ? "" : `${item.value}`}`}
                            {/* {item.value} */}
                          </p>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            )}
          </CardContent>
        </Collapse>
      </Card>

      {/* // Modal */}
      <div>
        <Dialog
          fullScreen={fullScreen}
          open={open}
          onClose={() => handleClose("ignore")}
          aria-labelledby="responsive-dialog-title"
          classes={{
            paper: "!max-w-4xl",
          }}
        >
          <DialogTitle id="responsive-dialog-title">
            {"Xác nhận thay đổi trạng thái MES"}
          </DialogTitle>
          <DialogContent>
            {/* DialogContentText mặc định tạo ra thẻ <p> nên phải thêm component="div" để tránh 2 thẻ <p> lòng nhau*/}
            <DialogContentText component="div">
              <Typography textAlign={"left"} whiteSpace={"nowrap"}>
                {`Bạn có chắc chắn muốn đổi`} <b>Trạng Thái MES</b> {`từ`}{" "}
                <b>{`${value?.value || "Trống"}`} </b> {`sang`}{" "}
                <b>{`${updateStatusLSX?.productionStatus?.value}`}</b>{" "}
                {`không ?`}
              </Typography>
              <div className="flex gap-2 mt-4">
                <label className="whitespace-nowrap font-semibold">
                  Ghi chú:{" "}
                </label>
                <TextArea
                  rows={2}
                  onChange={(e) => {
                    setUpdateStatusLSX({
                      ...updateStatusLSX,
                      description: e.target.value,
                    });
                  }}
                />
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              autoFocus
              onClick={() => {
                handleClose("ignore");
              }}
            >
              Đóng
            </Button>
            <Button
              onClick={() => {
                handleClose("confirm");
              }}
              autoFocus
            >
              Xác Nhận
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default CardItem;
